module.exports = __webpack_public_path__ + "a7026d3501350bc3b9b3e48af848b11a.png";